import React from 'react'
import { FormattedMessage } from 'react-intl'
import { ReactComponent as Download } from '@mike/mike-shared-frontend/media/icons/Download'
import { ButtonProps as MuiButtonProps } from '@mui/material/Button'
import messages from '../../shared/messages'
import { iconSecondaryStyle, StyledIconButton } from './iconStyles'

const DownloadButton = (buttonProps: MuiButtonProps) => {
  return (
    <StyledIconButton {...buttonProps}>
      <Download className={iconSecondaryStyle(buttonProps.disabled)} />
      <FormattedMessage id={messages.download.id} />
    </StyledIconButton>
  )
}

export default DownloadButton
